/**
 * Account screen placeholder.
 *
 * Later replaced by Owner-administration flows: role management, support
 * impersonation consent, data export, and account deletion (Req 24-25). Loaded
 * lazily per route (see `screens.tsx`).
 */
import type { ReactElement } from "react";

export default function AccountScreen(): ReactElement {
  return (
    <section aria-labelledby="screen-heading" data-screen="account">
      <h1 id="screen-heading">Account</h1>
      <p>Owner administration screens plug in here.</p>
    </section>
  );
}
